import {
  Button,
  ButtonVariant,
  ButtonSize,
  Badge,
  BadgeSize,
  BadgeVariant
} from "shared/components";
import { DiscountInfoTooltip } from "views/discounts/components/DiscountInfoTooltip";
import { DiscountCode, CustomDiscount } from "views/discounts/types";
import { SelfServeOption, ManualOption } from "../../../types";
import { MultiplicationSignIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Money } from "shared/types/application";
import { useAuthContext } from "providers/Auth";
import { HugeiconsIcon } from "@hugeicons/react";

interface DiscountActionCellProps {
  appliedDiscounts: Record<string, DiscountCode | CustomDiscount | null>;
  rowKey: string;
  propertyApplicationFee: number | null | undefined;
  template: {
    verification_template?: {
      applicant_fee?: Money;
    };
  } | null;
  setAppliedDiscounts: (
    discounts: Record<string, DiscountCode | CustomDiscount | null>
  ) => void;
  option: SelfServeOption | ManualOption;
  setSelectedApplicantEmail: (email: string) => void;
  setShowApplyDiscountModal: (show: boolean) => void;
}

export const DiscountActionCell = ({
  appliedDiscounts,
  rowKey,
  propertyApplicationFee,
  template,
  setAppliedDiscounts: _,
  option,
  setSelectedApplicantEmail,
  setShowApplyDiscountModal
}: DiscountActionCellProps) => {
  const { permissions } = useAuthContext();
  const handleApplyClick = () => {
    const email =
      option.type === "self-serve"
        ? option.email
        : `${option.first_name} ${option.last_name}`;
    setSelectedApplicantEmail(email || "");
    setShowApplyDiscountModal(true);
  };
  if (
    !(
      permissions.canApplyActiveDiscounts || permissions.canApplyCustomDiscounts
    )
  )
    return (
      <div className="flex justify-center">
        <Button
          variant={ButtonVariant.TEXT}
          size={ButtonSize.SM}
          tooltip="You don't have permission to apply discounts. Please contact an administrator"
        >
          Apply
        </Button>
      </div>
    );

  if (appliedDiscounts[rowKey])
    return (
      <Badge
        size={BadgeSize.SM}
        tooltip={
          <DiscountInfoTooltip
            onlyContent
            showPercentageAsAmount={true}
            discountAmountInCents={appliedDiscounts[rowKey].discount_amount}
            discount={appliedDiscounts[rowKey]}
            baseFeeInCents={
              propertyApplicationFee
                ? propertyApplicationFee
                : template?.verification_template?.applicant_fee?.cents || 0
            }
          />
        }
        variant={BadgeVariant.ERROR}
        rightElement={
          <HugeiconsIcon
            icon={MultiplicationSignIcon}
            size={12}
            strokeWidth={2}
            className="text-danger-500 hover:text-danger-700"
          />
        }
      ></Badge>
    );

  return (
    <div className="flex justify-center">
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={handleApplyClick}
      >
        Apply
      </Button>
    </div>
  );
};
